function handleJsonParse(line: string, result: object[]) {
  try {
    result.push(JSON.parse(line.trim()));
  } catch {
    console.error('Failed to parse JSONL line: ', line);
  }
}

function processLines(partialLine: string, result: object[]): string {
  const lines = partialLine.split('\n');
  const lastPartial = lines.pop() || '';
  for (const line of lines) {
    if (line.trim()) {
      handleJsonParse(line, result);
    }
  }
  return lastPartial;
}

export async function processJsonLinesStream(response: any) {
  const reader = response?.getReader();
  const decoder = new TextDecoder();
  let partialLine = '';

  if (!reader) {
    throw new Error('No readable stream found');
  }

  const result: object[] = [];

  while (true) {
    const { done, value } = await reader.read();
    if (done) break;
    partialLine += decoder.decode(value, { stream: true });
    partialLine = processLines(partialLine, result);
  }

  return result;
}
